// extracted by mini-css-extract-plugin
export default {"btnFiles":"style_btnFiles__oo1G2","trash":"style_trash__KzOLP","trashAnimation":"style_trashAnimation__YMMne","inputText":"style_inputText__xgDKm"};